import AxiosWrapper from "../../basecomp/base/AxiosWrapper";
// import { useToast } from "../../basecomp/components/provider/ToastProvider";
import { fetchData, postData } from "../apis/apis";

// const { handleToastOpen } = useToast()
// export async function GetUserType(){

//         let response = await AxiosWrapper.axiosGetCallWithToken("/ticket-tool/getusertype",new FormData())
//         return response
        
// }
    
export async function GetDevelopers() {
    // let response = await AxiosWrapper.axiosGetCallWithToken("/ticket-tool/getDevelopers",new FormData())
    let response= fetchData("/getDevelopers",new FormData())

    return response
    
}
export async function GetComments(id) {
    // let response = await AxiosWrapper.axiosGetCallWithToken(`/ticket-tool/getComments?id=${id}`,new FormData())
    let response= fetchData(`/getComments?id=${id}`,new FormData())

    return response
    
}
export async function GetTools() {
    // let response = await AxiosWrapper.axiosGetCallWithToken("/ticket-tool/getTools",new FormData())
    try{

    
    let response= fetchData("/getTools",new FormData())
    
    return response
    }
    catch(error){
        throw error
        // handleToastOpen("error","Somthing went wrong in getting tools")
    }
}

export async function AddComment(data) {
    // let response = await AxiosWrapper.axiosPostCallWithToken("/ticket-tool/addcomment",data)
    // return response
        try {
        // let response = await AxiosWrapper.axiosPostCallWithToken("/ticket-tool/addcomment", data)
        let response = await postData("/addcomment",data)
        // console.log(response);
        return response
    }
    catch (error) {
        console.log("in vm");
        console.log(error);
        throw error;
    }
}

export async function StartProject(data) {
    // let response = await AxiosWrapper.axiosPostCallWithToken("/ticket-tool/startproject",data)
        let response = await postData("/startproject",data)

    return response
}
export async function MarkComplete(data) {
    // let response = await AxiosWrapper.axiosPostCallWithToken("/ticket-tool/markcomplete",data)
    let response = await postData("/markcomplete",data)
    return response
}
export async function getPresignedUrlForFiles(data) {
    // let response = await AxiosWrapper.axiosPostCallWithToken("/ticket-tool/getPresignedUrlForFiles",data)
        let response = await postData("/getPresignedUrlForFiles",data)

    return response
}